<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [subtitle]="subtitle"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canCreateNewExcel]="this.isAdministrator"
    [canImportExcel]="this.isAdministrator"
    [canExportExcel]="true"
    (onClearFilterEvent)="onClearFilters()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onNewEvent)="onNew()"
    (onImportEvent)="onImport()"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
            <mat-label>Nom</mat-label>
            <input matInput autocomplete="off" type="text" (keyup)="inputChanged()" [(ngModel)]="groupSearchCriteriaModel.GroupName">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Type</mat-label>
              <ng-multiselect-dropdown placeholder="" [settings]="dropdownSettings" [(ngModel)]="selectedItemsGroupTypes"
                [data]="dropdownListGroupTypes" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'Type')"
                (onSelectAll)="onSelectAll($event,'Type')" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Actif</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsIsActive"
                [data]="dropdownListIsActive" (onSelect)="onItemSelect()" placeholder='Sélectionner...'
                (onSelectAll)="onSelectAll($event,'IsActive')" (onDeSelectAll)="onSelectAll($event, 'IsActive')"
                (onDeSelect)="onItemSelect()" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>BAP</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [(ngModel)]="selectedItemsIsVoucher"
                [data]="dropdownListIsVoucher" (onSelect)="onItemSelect()" placeholder='Sélectionner...'
                (onSelectAll)="onSelectAll($event,'IsVoucher')" (onDeSelectAll)="onSelectAll($event, 'IsVoucher')"
                (onDeSelect)="onItemSelect()" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-table [data]="dataItems"
  [tableActions]="tableActions"
  [serverPagination]="true"
  [tableIndications]="tableIndications"
  [columnsDefinition]="columnsDefinition"
  [onChangeStatus]="onChangeStatus"
  [configKey]="configKey"
  [exportFileName]="exportFileName"
  [onExport]="getGroupsForExport"
  [onExportDataSourceAvailable]="onExportDataSourceAvailable"
  [isActiveReadOnly] = "!this.isAdministrator"
  (onPageChange)="onPageChange($event)"
  (onSortChange)="onSortChange($event)"
  [length]="paginatorLength"
  [onExportExcelCaller]="onExportExcelCaller"
  [onFiltersCleared]="onFiltersCleared"
  ngDefaultControl>
</app-table>
